import React from 'react';
import {connect} from "react-redux";
import {getActiveLanguage, getTranslate, setActiveLanguage} from 'react-localize-redux';

import API from '../api';

import {About, Footer, FunFacts, Header, Home, PortFolio, ScrollSection, Services, Skill} from '../components';

export default connect(
	state => ({
		api            : API,
		translate      : getTranslate(state.locale),
		currentLanguage: getActiveLanguage(state.locale).code
	}),
	dispatch => ({
		setActiveLanguage: lang => dispatch(setActiveLanguage(lang))
	}))(
	(props) => (
		<ScrollSection>
			<Header {...props}/>
			<Home {...props}/>
			<About {...props}/>
			<Services {...props}/>
			<Skill {...props}/>
			<PortFolio {...props}/>
			<FunFacts {...props}/>
			<Footer {...props}/>
		</ScrollSection>
	)
);

// http://www.bdinfosys.com/demo/materialx/



// WEBPACK FOOTER //
// ./src/pages/Main.js